import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
import ModalContainer from './ModalContainer';
import CustomModal from './Custom';
export class ModalComponent extends React.Component {
}
class BaseModal extends ModalComponent {
    constructor(props) {
        super(props);
        this.transitionShowModal = () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: true,
                    willHidden: false,
                });
            }, 400);
        };
        this.transitionHiddenModal = () => {
            this.setState({
                willHidden: true,
            });
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: false,
                    willHidden: false,
                });
            }, 400);
        };
        this.handleCancel = () => {
            const { onCancel } = this.props;
            onCancel && onCancel();
        };
        this.wrapClick = () => {
            if (this.props.maskClick) {
                this.props.maskClick();
            }
        };
        this.contentClick = (e) => {
            e.stopPropagation();
        };
        this.state = {
            show: props.visible,
            willHidden: false,
        };
    }
    componentDidUpdate(preProps) {
        if (preProps.visible && !this.props.visible) {
            // 隐藏
            this.transitionHiddenModal();
        }
        else if (!preProps.visible && this.props.visible) {
            // 显示
            this.transitionShowModal();
        }
    }
    render() {
        const { visible, className, title, children, showCloseIcon, preMunt, animateIn, animateOut, translateX = 0, translateY = 0 } = this.props;
        const { show, willHidden } = this.state;
        if (!visible && !preMunt && !show) {
            return null;
        }
        return (<ModalContainer visible={show || visible} className={className}>
        <div className='cfm_modal_mask'/>
        <div className='cfm_modal_wrap' onClick={this.wrapClick} style={{ 'transform': `translate(${translateX}px, ${translateY}px)` }}>
          <div className={classnames('cfm_modal_container', animateIn && `cfm_confirm_${animateIn}_will_show`, animateOut && willHidden && `cfm_confirm_${animateOut}_will_hidden`)} onClick={(e) => this.contentClick(e)}>
            {showCloseIcon ? <div className='cfm_modal_close' onClick={this.handleCancel}>
                <Icon type="close" color='#666'/>
              </div> : null}
            {!!title ? <div className={`cfm_modal_title`}>
                {title}
              </div> : null}
            <div className='cfm_modal_content'>
              {children}
            </div>
          </div>
        </div>
      </ModalContainer>);
    }
}
BaseModal.CustomModal = CustomModal;
BaseModal.defaultProps = {
    className: '',
    title: '',
    showCloseIcon: false,
    preMunt: false,
};
export default BaseModal;



// WEBPACK FOOTER //
// ./components/modal/Modal.tsx